export default __webpack_public_path__ + "static/icons-sprite-e676f51d6a516d6d0a2f9541e15fea7f.svg";